import { EcranResultat } from '@/components/resultat/ecran-resultat';
import { type ChoixResultat, rechercheResultatSchema } from '@/lib/params-recherche';
import { PageLayout } from '@pms-digital/design-system';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/resultat/$id/')({
  validateSearch: (recherche) => rechercheResultatSchema.parse(recherche),
  component: ResultatPage,
});

/** Page of the package, « default » (1 200 px) as every result screen: its margins are the charter's. */
function ResultatPage() {
  const { id } = Route.useParams();
  const { noyau } = Route.useSearch();
  const navigate = Route.useNavigate();

  function choisirOnglet(suivant: ChoixResultat) {
    void navigate({ search: { noyau: suivant }, replace: true });
  }

  return (
    <PageLayout width="default">
      <section className="flex flex-col">
        <EcranResultat id={id} noyau={noyau} onChoisirOnglet={choisirOnglet} />
      </section>
    </PageLayout>
  );
}
